import type { ViewConfig } from "@kontextwerk/control-web-frame"

export const workspaceConfig = {
  viewId: "organization",
  subview: { id: "customer", parentPageId: "administration", parentTabTitle: "Ansprechpartner" },
} satisfies NonNullable<ViewConfig["workspace"]>
